var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUpdates(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.375 1.62765C24.375 0.972643 23.9789 0.378567 23.3695 0.124688C22.7602 -0.12919 22.0645 0.0129818 21.5973 0.475041L19.3832 2.69394C16.9457 5.13118 13.6398 6.50212 10.1918 6.50212H9.75H8.125H3.25C1.45742 6.50212 0 7.95938 0 9.75177V14.6262C0 16.4186 1.45742 17.8759 3.25 17.8759V24.3752C3.25 25.2739 3.97617 26 4.875 26H8.125C9.02383 26 9.75 25.2739 9.75 24.3752V17.8759H10.1918C13.6398 17.8759 16.9457 19.2468 19.3832 21.6841L21.5973 23.8979C22.0645 24.365 22.7602 24.5021 23.3695 24.2482C23.9789 23.9944 24.375 23.4054 24.375 22.7453V15.2508C25.3195 14.804 26 13.6006 26 12.1839C26 10.7673 25.3195 9.5639 24.375 9.11707V1.62765ZM21.125 5.52215V12.189V18.8559C18.1391 16.1394 14.2441 14.6262 10.1918 14.6262H9.75V9.75177H10.1918C14.2441 9.75177 18.1391 8.23865 21.125 5.52215Z",
    fill: "#17F1B7"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpdates);
export default __webpack_public_path__ + "static/media/updates.a84bc7b8d61944e024311e30a71fac22.svg";
export { ForwardRef as ReactComponent };